module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sb-00988e025b134db9744329626d126aab.svg";